import { useTranslation } from 'react-i18next';
import { EmbeddedStatus, KBType } from '@/modules/gpt-chats/models/kb';
import { useKbNotificationHandler } from '../../hooks/use-kb-notifications';
import { useNotificationListener } from '@/modules/gpt-chats/hooks/use-notification-listener';
import { Check, Loader, RefreshCcw, X } from 'lucide-react';

const STATUS_CONFIG = {
  [EmbeddedStatus.COMPLETED]: {
    icon: Check,
    textKey: 'EMBEDDED',
    className:
      'bg-green-100 text-green-700 dark:bg-green-950/60 dark:text-green-300 dark:border dark:border-green-700',
  },
  [EmbeddedStatus.FAILED]: {
    icon: X,
    textKey: 'FAILED',
    className:
      'bg-red-100 text-red-700 dark:bg-red-950/60 dark:text-red-300 dark:border dark:border-red-700',
  },
  [EmbeddedStatus.PENDING]: {
    icon: Loader,
    textKey: 'PENDING',
    className:
      'bg-yellow-100 text-yellow-700 dark:bg-yellow-950/60 dark:text-yellow-300 dark:border dark:border-yellow-700',
  },
  [EmbeddedStatus.PROCESSING]: {
    icon: RefreshCcw,
    textKey: 'PROCESSING',
    className:
      'bg-blue-100 text-blue-700 dark:bg-blue-950/60 dark:text-blue-300 dark:border dark:border-blue-700',
  },
};

export const EmbedStatus = ({
  status,
  kbId,
  type,
}: {
  status: EmbeddedStatus;
  kbId?: string;
  type?: KBType;
}) => {
  const { t } = useTranslation();
  const handleNotification = useKbNotificationHandler({
    kbId: kbId || '',
    type: type || KBType.FILE,
  });

  useNotificationListener('agent-knowledge-base', handleNotification);

  const config = STATUS_CONFIG[status];
  const Icon = config?.icon;

  return (
    <div
      className={`flex w-fit flex-row items-center gap-1 rounded-full px-2 py-1 pr-3 text-xs ${config?.className || 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300'}`}
    >
      {Icon && <Icon className="h-4 w-4" />}
      {config?.textKey ? t(config.textKey) : status}
    </div>
  );
};
